import {isGreekText} from 'providers/ferries/autocompleteResultsBasedOnTypedLanguage/utils';
import charsToLatin from 'helpers/charsToLatin.json';

const matchText = (text, search) => text.replace(/\s/g,'').toLowerCase().includes(
  search.replace(/\s/g,'').toLowerCase()
);

const removeAccent = (str) => isGreekText(str) ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : str;

const onlyCharacters = (text) => text.replace(/\d/g,'').replace(/[@!^&/\\#,+()$~%.'":*?<>{}_|=\-`]/g, '');

const getTransportable = (number, plural, singular) => {
  if (number === 1) {
    return singular.replace('{number}', number);
  }
  return plural.replace('{number}', number);
};

const joinWordsWithAmpLast = (items) => {
  const filteredItems = items.filter(Boolean);

  if (filteredItems.length === 1) {
    return filteredItems[0];
  } 
  const textItemsExceptLast = filteredItems.slice(0, -1).join(', ');
  const lastTrItem = filteredItems.slice(-1)[0];
  return `${textItemsExceptLast} & ${lastTrItem}`;
};

const replaceVowelsWithAd = (word) =>  word.replace(/\ba(?=\s*[aeiou])/ig, 'ad');

const initialName = (firstName, lastName) => `${firstName?.[0]?.toUpperCase()}${lastName?.[0]?.toUpperCase()}`;

const extractCountryCode = (label) => {
  const match = label.match(/\+\d+/);
  return match ? match[0] : '';
};

const extractCountryName = (label) => {
  const match = label.match(/^(.+?) \(\+\d+\)$/);
  return match ? match[1] : label;
};

const extractDialingCodeNumber = (text) => {
  if (!text) {
    return '';
  }

  const match = text.match(/\(\s*(\+\d+)\s*\)/);
  return match ? match[1] : '';
};

const formatLatinUppercaseByMode = (value, mode = 'full-name') => {
  let cleanupRegex;

  switch (mode) {
  case 'full-name':
    cleanupRegex = /[^a-zA-Z\s]/g;
    break;
  case 'plate-number':
    cleanupRegex = /[^a-zA-Z0-9]/g;
    break;
  default:
    cleanupRegex = /[^a-zA-Z]/g;
    break;
  }

  return value
    .split('')
    .map((char) => charsToLatin[char] || char)
    .join('')
    .replace(cleanupRegex, '')
    .toUpperCase();
};

export {
  matchText,
  onlyCharacters,
  removeAccent,
  getTransportable,
  joinWordsWithAmpLast,
  replaceVowelsWithAd,
  initialName,
  extractCountryCode,
  extractCountryName,
  extractDialingCodeNumber,
  formatLatinUppercaseByMode
};